import DeleteSubjectButton from '../../components/subjects/delete-button';
import { NavLink } from 'react-router-dom';
import React from 'react';
import SubjectIcon from '../../components/subjects/icon';

//

function _makeCallable(value) {
  return typeof value === 'function' ? value : () => value;
}

//

function getSubjectNavigationItem({
  actions,
  editMode,
  handleDeletedSubject,
  handleDeletingSubject,
  handleFailedToDeleteSubject,
  navRoot,
  subject,
}) {
  return {
    ...(editMode
      ? {
          component: 'div',
          disabled: true,
          metaItem: (
            <>
              {actions.includes('delete') && (
                <DeleteSubjectButton
                  className="side-navigation__delete-subject"
                  onDelete={handleDeletedSubject.bind(null, 'deleted')}
                  onDeleting={handleDeletingSubject}
                  onError={handleFailedToDeleteSubject}
                  subjectId={subject.id}
                />
              )}
            </>
          ),
        }
      : {
          activeClassName: 'mdc-deprecated-list-item--selected',
          component: NavLink,
          exact: false,
          graphic: <SubjectIcon subjectName={subject.subject_name} />,
          to: `${_makeCallable(navRoot)(subject)}/${subject.id}`,
        }),
    key: subject.id,
    primaryText: subject.subject_name,
    'data-testid': subject.id,
  };
}

export default getSubjectNavigationItem;
